import { cn } from "@/shared/ui/cn";
import { BrandMark } from "./BrandMark";

interface BrandProps {
  /** Icon only (the collapsed sidebar rail). */
  compact?: boolean;
  size?: "sm" | "md";
  className?: string;
}

/** The product mark: the accent tile with the A + scan-frame glyphs, plus the name. One place, so login, shell and onboarding agree. */
export function Brand({ compact = false, size = "sm", className }: BrandProps) {
  return (
    <span className={cn("inline-flex items-center", className)}>
      <span
        aria-hidden={!compact}
        aria-label={compact ? "NexBorg Access" : undefined}
        className={cn(
          "inline-flex items-center justify-center bg-accent text-on-accent",
          size === "sm" ? "size-6 rounded-sm" : "size-7 rounded-md",
        )}
      >
        <BrandMark className="w-4/5" />
      </span>
      {!compact ? (
        <span className="ml-2 truncate text-body font-semibold text-fg">NexBorg Access</span>
      ) : null}
    </span>
  );
}
